/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Resource types exposed via the API.
 */
export enum ResourceKind {
  CERTIFICATE_SIGNING_REQUEST = 'CertificateSigningRequest',
  ENROLLMENT_REQUEST = 'EnrollmentRequest',
  DEVICE = 'Device',
  FLEET = 'Fleet',
  REPOSITORY = 'Repository',
  RESOURCE_SYNC = 'ResourceSync',
  TEMPLATE_VERSION = 'TemplateVersion',
  AUTH_PROVIDER = 'AuthProvider',
}
